import React from 'react';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { MetaInfoDescription } from './MetaInfoDescription';
import { DateFormat } from '../../DateFormat';
import { PersonLink } from './PersonLink';
import ILink from '../../../../types/ILink';

export function CreateDateMetaInfo({ createdDate, createdBy }: { createdDate: string; createdBy?: ILink }) {
  const { t } = useSonTranslation('MetaInfo');

  return (
    <MetaInfoDescription term={t(`creationDate`)}>
      <p>
        {t('on')} <DateFormat date={createdDate} />
        {createdBy && (
          <>
            {' '}
            {t('from')} <PersonLink person={createdBy} />
          </>
        )}
      </p>
    </MetaInfoDescription>
  );
}
